import type { PackRecord, ProfileRecord } from '../types';

interface ActivityDetails {
  date: string;
  isUpdate: boolean;
  exampleNote?: string;
  version?: string;
}

export type CreatorActivityItem =
  | (ActivityDetails & { kind: 'profile'; record: ProfileRecord })
  | (ActivityDetails & { kind: 'pack'; record: PackRecord; revisedCount: number; addedCount: number });

/** One latest event per pack or individual upload, without repeating pack members. */
export function creatorActivity(profiles: ProfileRecord[], packs: PackRecord[], allPackProfiles = profiles): CreatorActivityItem[] {
  const packIds = new Set(packs.map((pack) => pack.id));
  const profilesById = new Map(allPackProfiles.map((profile) => [profile.id, profile]));
  const activity: CreatorActivityItem[] = packs.map((pack) => {
    const members = pack.profileIds.map((id) => profilesById.get(id)).filter((profile): profile is ProfileRecord => Boolean(profile));
    const lastUpdate = Date.parse(pack.latestUpdatedAt);
    const isUpdate = lastUpdate > Date.parse(pack.createdAt);
    return {
      kind: 'pack',
      record: pack,
      date: pack.latestUpdatedAt,
      isUpdate,
      version: isUpdate ? undefined : '1.0',
      revisedCount: members.filter((profile) => Date.parse(profile.updatedAt) === lastUpdate && lastUpdate > Date.parse(profile.uploadedAt)).length,
      addedCount: members.filter((profile) => Date.parse(profile.uploadedAt) === lastUpdate && lastUpdate > Date.parse(pack.createdAt)).length,
    };
  });
  for (const profile of profiles) {
    if (profile.packId && packIds.has(profile.packId)) continue;
    const isUpdate = Date.parse(profile.updatedAt) > Date.parse(profile.uploadedAt);
    activity.push({ kind: 'profile', record: profile, date: profile.updatedAt, isUpdate, version: isUpdate ? undefined : '1.0' });
  }
  return activity.sort((left, right) => Date.parse(right.date) - Date.parse(left.date)
    || left.record.name.localeCompare(right.record.name, undefined, { numeric: true })
    || left.record.id.localeCompare(right.record.id));
}
